import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toHandlers as _toHandlers, withKeys as _withKeys, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = { class: "text-muted fw-bold" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = {
  class: "table-responsive pis-scroll position-relative",
  style: {"min-height":"5rem"}
}
const _hoisted_9 = { class: "table table-sm table-striped mt-2" }
const _hoisted_10 = { class: "small" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "d-flex flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ImageGallery = _resolveComponent("ImageGallery")!
  const _component_Clickable = _resolveComponent("Clickable")!
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_PisLink = _resolveComponent("PisLink")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.prm.userFields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prm.userFields, (uf, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "mb-4 text-info"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_Icon, {
                  glyph: "info",
                  class: "text-info"
                }),
                _createTextVNode(" " + _toDisplayString(uf.name), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uf.values, (val, valIndex) => {
                return (_openBlock(), _createElementBlock("div", { key: valIndex }, _toDisplayString(val), 1))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.prm.images)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ImageGallery, {
            images: _ctx.productsImages,
            alwaysShowThumbnails: true
          }, null, 8, ["images"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalCount) + " " + _toDisplayString(_ctx.t('Products', true)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Dropdown, {
          open: _ctx.isAutocompleteVisible,
          "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAutocompleteVisible) = $event)),
          "min-width": "200px",
          items: _ctx.autocomplete?.matches
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_Clickable, {
              class: "d-flex align-items-center dropdown-item",
              onClick: ($event: any) => (_ctx.onSearch(item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          activator: _withCtx(({ on }) => [
            _createVNode(_component_FormInputClearable, _mergeProps({
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
              modelModifiers: { trim: true }
            }, _toHandlers(on), {
              onKeyup: [
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.search($event))),
                _withKeys(_ctx.searchNow, ["enter"])
              ],
              onChange: _ctx.search,
              onClear: _ctx.search,
              placeholder: _ctx.t('SearchProductsInputPlaceholder')
            }), null, 16, ["modelValue", "onKeyup", "onChange", "onClear", "placeholder"])
          ]),
          _: 1
        }, 8, ["open", "items"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Loader, { visible: _ctx.isLoading }, null, 8, ["visible"]),
      _createElementVNode("table", _hoisted_9, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.columns, (col) => {
              return (_openBlock(), _createElementBlock("th", {
                key: col.dataField
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(col.text), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.columns, (col) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: col.dataField
                }, [
                  (row && row.values && row.values[col.dataField])
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.values[col.dataField], (val, vIndex) => {
                        return (_openBlock(), _createElementBlock("div", { key: vIndex }, [
                          (val.link)
                            ? (_openBlock(), _createBlock(_component_PisLink, {
                                key: 0,
                                instance: _ctx.instance,
                                link: val.link,
                                "clear-search": true
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(val.link.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["instance", "link"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(val.text), 1)
                              ], 64)),
                          (val.tooltip)
                            ? (_openBlock(), _createBlock(_component_Tooltip, {
                                key: 2,
                                text: val.tooltip,
                                placement: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Icon, {
                                    glyph: "info",
                                    class: "text-primary ms-1"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["text"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Pagination, {
        total: _ctx.pageCount,
        current: _ctx.page,
        onChange: _ctx.onPageChange
      }, null, 8, ["total", "current", "onChange"])
    ])
  ], 64))
}